import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../api/apiClient";
import IconComponent from "./Icon";
import { FiInfo, FiX } from "react-icons/fi";
import { FaChevronDown } from "react-icons/fa";
import Book from "./Book";
import { FaCircleXmark, FaRegCircleXmark, FaX } from "react-icons/fa6";

const noCover = 'https://dryofg8nmyqjw.cloudfront.net/images/no-cover.png'

const AddSerieForm = ({ allAuthors, allBooks}) => {
    const dropDownAuthorRef = useRef(null);
    const booksRef = useRef(null);
    const [showAllAuthors, setShowAllAuthors] = useState(false);
    const [showAllBooks, setShowAllBooks] = useState(false);
    const [authorSearchString, setAuthorSearchString] = useState('');
    const [addedBooks, setAddedBooks] = useState([]);
    const [bookSearchString, setBookSearchString] = useState('');
    const [editedSerieInfo, setEditSerieInfo] = useState({
        name: '',
        author: '',
        description: '',
    });
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleSaveSerie = async () => {
        setLoading(true)
        const formatData = {
            seriesName: editedSerieInfo.name,
            seriesAuthor: editedSerieInfo.author,
            seriesDescription: editedSerieInfo.description,
        }


        await axiosInstance.post('/admin/addSerie', formatData)

        await axiosInstance.get('/getAllSeries').then(async (data) => {
            const newSerieId = data.find((serie) => serie.name === editedSerieInfo.name)?.serie_id;

            if (newSerieId) {
                // Maak een array van promises
                const updatePromises = addedBooks.map((book) => {
                    const formatBookData = {
                        "title": book['Title'],
                        "author_name": book['Author'],
                        "author_l_f": book['Author l-f'],
                        "additional_authors": book['Additional Authors'],
                        "publisher": book['Publisher'],
                        "binding": book['Binding'],
                        "number_of_pages": book['Number of Pages'],
                        "year_published": book['Year Published'],
                        "original_publication_year": book['Original Publication Year'],
                        "isbn": book['ISBN'],
                        "isbn13": book['ISBN13'],
                        "average_rating": book['Average Rating'],
                        "genres": book['Genres'],
                        "serie_id": newSerieId,
                        "serie_position": book['Serie Position'],
                    };

                    return axiosInstance.post(`/admin/updateBook/${book['Book Id']}`, formatBookData);
                });

                // Wacht tot alle boeken zijn geüpdatet
                await Promise.all(updatePromises);

                // Daarna pas navigeren
                navigate(`/stats/details?type=serie&value=${newSerieId}`);
            } else {
                alert('Books could not be added to serie');
            }
        });
    }

    const removeBook = (book) => {
        setAddedBooks(addedBooks.filter((b) => b['Book Id'] !== book['Book Id']));
    };

    const toggleSelection = (book) => {
        if (addedBooks.find((b) => b['Book Id'] === book['Book Id'])) {
            setAddedBooks(addedBooks.filter((b) => b['Book Id'] !== book['Book Id']));
        } else {
            setAddedBooks([...addedBooks, book]);
        }
    };


    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropDownAuthorRef.current && !dropDownAuthorRef.current.contains(event.target)) {
                setShowAllAuthors(false);
            }

            if (booksRef.current && !booksRef.current.contains(event.target)) {
                setShowAllBooks(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
        
    }, []);

    if (loading) {
        return (
             <div className="loader"></div> 
        )
    }

    return (
        <div className="bg-white rounded-3xl shadow-lg p-4 min-h-20 mt-[40px]">
            <form onSubmit={(e) => {e.preventDefault(); handleSaveSerie(); setEditSerieInfo({});}}>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                        <label htmlFor="name" className="block mb-2 text-sm font-medium text-gray-900">
                            Name
                        </label>
                        <input
                            type="text"
                            id="title"
                            value={editedSerieInfo['name']}
                            onChange={(e) => setEditSerieInfo({...editedSerieInfo, 'name': e.target.value})}
                            className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                            required
                        />
                    </div>

                        <div className="relative group" ref={dropDownAuthorRef}>
                            <label htmlFor="search" className="block mb-2 text-sm font-medium text-gray-900">Author</label>
                            <input
                                className="inline-flex justify-center w-full px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-blue-500"
                                value={showAllAuthors ? authorSearchString : editedSerieInfo.author}
                                id="author"
                                onChange={(e) => {setAuthorSearchString(e.target.value)}}
                                onFocus={() => setShowAllAuthors(true)}
                                placeholder="Search author"
                                type="text"
                                required
                                onClick={() => setShowAllAuthors(true)}

                            />
                            {
                                showAllAuthors && (() => {
                                    const filteredAuthors = allAuthors.filter((author) =>
                                    Object.entries(author).some(([key, value]) => {
                                        // const excludedFields = ['description'];
                                        // if (excludedFields.includes(key)) return false;
                                        return String(value).toLowerCase().includes(authorSearchString.toLowerCase());
                                    })
                                    );

                                    return (
                                    <div id="dropdown-menu" className="absolute w-full right-0 mt-2 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 p-1 space-y-1 overflow-auto max-h-60">
                                        {
                                        filteredAuthors.length > 0 ? (
                                            filteredAuthors.map((author, idx) => (
                                            <div
                                                key={idx}
                                                className="block px-4 py-2 text-gray-700 hover:bg-gray-100 active:bg-blue-100 cursor-pointer rounded-md"
                                                onClick={() => {
                                                setEditSerieInfo({...editedSerieInfo, 'author': author['author_name']});
                                                setAuthorSearchString(`${author['author_name']}`);
                                                setShowAllAuthors(false);
                                                }}
                                            >
                                                {author['author_name']}
                                            </div>
                                            ))
                                        ) : (
                                            <div className="block px-4 py-2 text-gray-500 italic">
                                            No authors found
                                            </div>
                                        )
                                        }
                                    </div>
                                    );
                                })()
                            }
                        </div>
                </div>

                <div className="mt-4">
                    <label htmlFor="name" className="block mb-2 text-sm font-medium text-gray-900">
                        Description
                    </label>
                    <textarea
                        type="text"
                        id="description"
                        value={editedSerieInfo['description']}
                        onChange={(e) => setEditSerieInfo({...editedSerieInfo, 'description': e.target.value})}
                        className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  min-h-32"
                    />
                </div>
                {/* add books to serie */}
                <div className="mt-4">
                    <div className="relative" ref={booksRef}>
                            <label htmlFor="search" className="block mb-2 text-sm font-medium text-gray-900">Books in serie</label>
                            <input
                                className="inline-flex justify-center w-full px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-blue-500"
                                value={bookSearchString}
                                id="books"
                                onChange={(e) => {setBookSearchString(e.target.value)}}
                                placeholder="Search books"
                                type="text"
                                onClick={() => setShowAllBooks(true)}
                                onFocus={() => setShowAllBooks(true)}

                            />
                            {
                                showAllBooks && (() => {
                                    const filteredBooks = allBooks.filter((book) =>
                                    Object.entries(book).some(([key, value]) => {
                                        // const excludedFields = ['description'];
                                        // if (excludedFields.includes(key)) return false;
                                        return String(value).toLowerCase().includes(bookSearchString.toLowerCase());
                                    })
                                    );

                                    return (
                                    <div id="dropdown-menu" className="absolute w-full right-0 mt-2 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 p-1 space-y-1 overflow-auto max-h-60 z-50">
                                        {
                                        filteredBooks.length > 0 ? (
                                            filteredBooks.map((book, idx) => (
                                            <div
                                                key={idx}
                                                className={`block px-4 py-2 text-gray-700 hover:bg-gray-100 active:bg-blue-100 cursor-pointer rounded-md${addedBooks.includes(book['Book Id']) ? ' bg-[#8784D8] text-white' : ''}`}
                                                onClick={() => {
                                                    toggleSelection(book);
                                                    setShowAllBooks(false);
                                                }}
                                            >
                                                {book['Title']} - {book['Author']}
                                            </div>
                                            ))
                                        ) : (
                                            <div className="block px-4 py-2 text-gray-500 italic">
                                            No books found
                                            </div>
                                        )
                                        }
                                    </div>
                                    );
                                })()
                            }
                        {/* <div
                            className="flex items-center border border-gray-300 text-gray-900 bg-[#F9FAFB] text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                            onClick={() => setShowAllBooks(!showAllBooks)}
                        >
                            {addedBooks.length === 0 && (
                                <span className="text-gray-400">Select books...</span>
                            )}
                            <div className='gap-2 flex'>
                                {addedBooks.map((book) => (
                                    <span
                                        key={book}
                                        className="flex items-center bg-[#8784D8] text-white text-sm px-2 py-1 rounded-full"
                                    >
                                        {allBooks.find((b) => b['Book Id'].toString() === book.toString())?.['Title']}
                                        <IconComponent 
                                            icon={FiX}
                                            onClick={() => {
                                                removeBook(book);
                                            }}
                                            color={'white'}
                                            className="w-4 h-4 ml-1 cursor-pointer"
                                        />
                                    </span>
                                ))}
                            </div>
                            <IconComponent width={"1em"} icon={FaChevronDown} className="text-gray-500 ml-auto text-xs" />
                        </div>

                        {showAllBooks && (
                            <ul className="absolute z-10 mt-1 w-full bg-white border border-gray-300 rounded-md shadow-lg max-h-60 overflow-auto">
                                {allBooks.map((book) => (
                                <li
                                    key={book['Book Id']}
                                    className={`px-4 py-2 cursor-pointer hover:bg-indigo-100 ${
                                        addedBooks.includes(book['Book Id']) ? 'bg-[#8784D8] text-white' : ''
                                    }`}
                                    onClick={() => toggleSelection(book)}
                                >
                                    {book['Title']}
                                </li>
                                ))}
                            </ul>
                        )} */}
                    </div>
                </div>
                {addedBooks.length > 0 && (
                    <div className=" flex grid grid-cols-3 gap-4">
                        
                        {addedBooks.map((book, key) => {
                            return(
                            <div className="bg-white rounded-3xl shadow-lg p-4 min-h-20 mt-[40px] flex gap-4 relative">
                                <IconComponent icon={FaRegCircleXmark} width={20} color="#000" className="absolute top-2 right-2 hover:cursor-pointer" onClick={() => removeBook(book)}/>
                                <div>
                                    <Book key={key} book={book} hideMeta={true} />
                                </div>
                                <div>
                                    <div className="h-1/2">
                                        <p className="font-bold">{book['Title']}</p>
                                        <p className="italic text-xs">{book['Author']}</p>
                                    </div>
                                    <div className="h-1/2">
                                        <label>Serie position</label>
                                        <input
                                            className="flex items-center border border-gray-300 text-gray-900 bg-[#F9FAFB] text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                                            id={`seriePosition-${book['Book Id']}`}
                                            value={book['Serie Position']}
                                            onChange={(e) => setAddedBooks(addedBooks.map((b) => b['Book Id'] === book['Book Id'] ? {...b, 'Serie Position': e.target.value} : b)) }
                                            required
                                            type="number"
                                            min="1"
                                        />
                                    </div>
                                </div>
                                
                            </div>
                        )})}
                    </div>
                )}

                <button
                    type="submit"
                    className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center mt-4"
                    >
                        Add serie
                </button>

           </form>
        </div>
    )

}

export default AddSerieForm